var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeploymentstatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9629",
    "data-name": "Group 9629",
    transform: "translate(-135.358 -157.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle_black_24dp_1_",
    "data-name": "circle_black_24dp (1)",
    transform: "translate(135.358 157.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9627",
    "data-name": "Group 9627",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39049",
    "data-name": "Rectangle 39049",
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9628",
    "data-name": "Group 9628",
    transform: "translate(1.535 1.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4770",
    "data-name": "Path 4770",
    d: "M11.965,2a9.965,9.965,0,1,0,9.965,9.965A9.956,9.956,0,0,0,11.965,2Zm0,17.938a7.972,7.972,0,1,1,7.972-7.972A7.97,7.97,0,0,1,11.965,19.938Z",
    transform: "translate(-2 -2)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4767",
    "data-name": "Path 4767",
    d: "M10.072,8.864v5.948h1.721l2.125-3.553v2.066h4.258V11.838H15.457V8.864H13.546l-1.753,2.974-.4-5.018L9.475,6.5,6.714,10.846H.378L.142,12.333H7.868Z",
    transform: "translate(137.233 157.696)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploymentstatus);
export default __webpack_public_path__ + "static/media/deploymentstatus.28d40433e17ae3c623586a3989190ebd.svg";
export { ForwardRef as ReactComponent };